import {
  createContext,
  ReactElement,
  ReactNode,
  useEffect,
  useState,
} from "react";

import { Brand } from "../generated/gql/graphql";
import useBrands from "../hooks/query/use-brands";

type BrandProviderContextType = {
  brands: Brand[];
};

export const BrandProviderContext = createContext<BrandProviderContextType>({
  brands: [],
});

type Props = {
  children: ReactNode | ReactNode[];
};

export default function BrandProvider(props: Props): ReactElement {
  const { children } = props;

  const [brands, setBrands] = useState<Brand[]>([]);

  const { data } = useBrands();

  useEffect(() => {
    if (!data) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    setBrands(data.brands.items);
  }, [data]);

  return (
    <BrandProviderContext.Provider value={{ brands }}>
      {children}
    </BrandProviderContext.Provider>
  );
}
